import React from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { Redirect, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import ErrorMessage from '../ErrorMessage';
import { findRolesInOrganization } from '../../helpers';
import { DOCTOR_DEFAULT_PAGE } from '../../constants/default';

const CheckOrganization = ({
  organizationRoles,
  initialSetupRequired,
  checkOrganization,
  children,
  organization
}) => {
  const user = useSelector(state => state.auth.user);
  const currentOrganization = useSelector(state => organization || state.auth.currentOrganization);
  const isManagement = useSelector(state => state.auth.isManagement);
  const currentLocation = useLocation();

  const initialSetupRoute = '/initial-setup';
  const hasLicense = get(currentOrganization, 'licenses', []).length > 0;

  if (isManagement || !checkOrganization) {
    return children;
  }

  if (!user.organizations.length) {
    return <ErrorMessage message="The user doesn't have organizations." />;
  }

  if (!currentOrganization) {
    return <ErrorMessage message="There is no organization selected." />;
  }

  if (
    organizationRoles.length &&
    !findRolesInOrganization(organizationRoles, currentOrganization)
  ) {
    return <ErrorMessage message="You don't have permission to access this section." />;
  }

  if (initialSetupRequired && !hasLicense) {
    return <Redirect to={initialSetupRoute} />;
  }

  if (currentLocation.pathname === initialSetupRoute && hasLicense) {
    return <Redirect to={DOCTOR_DEFAULT_PAGE} />;
  }

  return children;
};

CheckOrganization.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  organizationRoles: PropTypes.arrayOf(PropTypes.string)
};

CheckOrganization.defaultProps = {};

export default CheckOrganization;
